import { Component, OnInit } from '@angular/core';
import {ServiceErpService} from '../service-erp.service';

@Component({
  selector: 'app-all-reports-erp',
  templateUrl: './all-reports-erp.component.html',
  styleUrls: ['./all-reports-erp.component.scss']
})
export class AllReportsErpComponent implements OnInit {

  constructor(private service : ServiceErpService) { }

  statusDraft = 'Draft';
  statusInProgress = 'In progress';
  statusPending = 'Pending';
  statusFinished = 'Finished';
  statusCancelled = 'Cancelled';
  statusPublished = 'Published';
  statusArchived = 'Archived';

  projects = 0;
  procedures = 0;
  directives = 0;

  projectsByStatusDraft = 0;
  projectsByStatusInProgress = 0;
  projectsByStatusPending = 0;
  projectsByStatusFinished = 0;
  projectsByStatusCancelled = 0;

  proceduresByStatusDraft = 0;
  proceduresByStatusPublished = 0;
  proceduresByStatusArchived = 0;

  directivesByStatusDraft = 0;
  directivesByStatusPublished = 0;
  directivesByStatusArchived = 0;


  ngOnInit(): void {
    this.getAllProjects();
    this.getAllProcedures();
    this.getAllDirectives();
    
    this.getProjectsByStatusDraft(this.statusDraft);

    this.getProjectsByStatusInProgress(this.statusInProgress)
    this.getProjectsByStatusPending(this.statusPending)
    this.getProjectsByStatusFinished(this.statusFinished)
    this.getProjectsByStatusCancelled(this.statusCancelled)

    this.getProceduresByStatusDraft(this.statusDraft)
    this.getProceduresByStatusPublished(this.statusPublished)
    this.getProceduresByStatusArchived(this.statusArchived)

    this.getDirectivesByStatusDraft(this.statusDraft)
    this.getDirectivesByStatusPublished(this.statusPublished)
    this.getDirectivesByStatusArchived(this.statusArchived)


  }



  getAllProjects(){
    this.service.getAllProjects().subscribe((response : any) => {
      this.projects = response.number
    })
  }
  getAllProcedures(){
    this.service.getAllProcedures().subscribe((response : any) => {
      this.procedures = response.number
    })
  }
  getAllDirectives(){
    this.service.getAllDirectives().subscribe((response : any) => {
      this.directives = response.number
    })
  }

  ////////Projects By Status
  getProjectsByStatusDraft(valoare){
    this.service.getProjectsByStatus(valoare).subscribe((response : any) => {
      this.projectsByStatusDraft = response.number
    })
  }
  getProjectsByStatusInProgress(valoare){
    this.service.getProjectsByStatus(valoare).subscribe((response : any) => {
      this.projectsByStatusInProgress = response.number
    })
  }
  getProjectsByStatusPending(valoare){
    this.service.getProjectsByStatus(valoare).subscribe((response : any) => {
      this.projectsByStatusPending = response.number
    })
  }
  getProjectsByStatusFinished(valoare){
    this.service.getProjectsByStatus(valoare).subscribe((response : any) => {
      this.projectsByStatusFinished = response.number
    })
  }
  getProjectsByStatusCancelled(valoare){
    this.service.getProjectsByStatus(valoare).subscribe((response : any) => {
      this.projectsByStatusCancelled = response.number 
    })
  }
  //////////////////////////////////

  ///////Procedures by Status
  getProceduresByStatusDraft(valoare){
    this.service.getProcedureByStatus(valoare).subscribe((response : any) => {
      this.proceduresByStatusDraft  = response.number
    })
  }
  getProceduresByStatusPublished(valoare){
    this.service.getProcedureByStatus(valoare).subscribe((response : any) => {
      this.proceduresByStatusPublished = response.number
    })
  }
  getProceduresByStatusArchived(valoare){
    this.service.getProcedureByStatus(valoare).subscribe((response: any) => {
      this.proceduresByStatusArchived = response.number
    })
  }
  ///////////////////////////////////////////

  /////Directives by Status
  getDirectivesByStatusDraft(valoare){
    this.service.getDirectiveByStatus(valoare).subscribe((response : any) => {
      this.directivesByStatusDraft = response.number
    })
  }
  getDirectivesByStatusPublished(valoare){
    this.service.getDirectiveByStatus(valoare).subscribe((response : any) => {
      this.directivesByStatusPublished = response.number
    })
  }
  getDirectivesByStatusArchived(valoare){
    this.service.getDirectiveByStatus(valoare).subscribe((response : any) => {
      this.directivesByStatusArchived = response.number
    })
  }
}

//////asta e erp